module.exports = __webpack_public_path__ + "img/user-check-02.83b1ed5e.svg";